import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export interface Feedback {
    id: number;
    name: string | null;
    email: string | null;
    institution: string | null;
    message: string;
    ip_address: string | null;
    created_at?: string;
    updated_at?: string;
}

export const useAdminFeedbacks = (params?: { search?: string }) => {
    return useQuery({
        queryKey: ["admin-feedbacks", params],
        queryFn: async () => {
            const { data } = await axiosClient.get("/private/feedbacks", { params });
            return data.data as Feedback[];
        },
    });
};

export const useDeleteFeedback = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: number) => {
            const { data } = await axiosClient.delete(`/private/feedbacks/${id}`);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["admin-feedbacks"] });
        },
    });
};
